import {t} from 'i18n';

import {LoadState, RunGroupID} from "enums";
import {IRunGroup, IRunGroupAPI } from "interfaces";
// Not using index import for services to avoid circular dependency
import {axiosServer} from './API';

class _RunGroupsService {
    private loadPromise: Promise<IRunGroupAPI[]>;
    private loadState = LoadState.Initial;

    private runGroupNames = {
        [RunGroupID.OAuthFlow]: t('runGroups.OAuthFlow'),
        [RunGroupID.PersistCreds]: t('runGroups.PersistCreds'),
        [RunGroupID.Reregister]: t('runGroups.Reregister'),
        [RunGroupID.RevokeToken]: t('runGroups.RevokeToken'),
        [RunGroupID.MQTTBackoff]: t('runGroups.MQTTBackoff'),
        [RunGroupID.MQTTPersist]: t('runGroups.MQTTPersist'),
        [RunGroupID.MQTTReconnect]: t('runGroups.MQTTReconnect'),
        [RunGroupID.Network]: t('runGroups.Network'),
        [RunGroupID.MessageValidation]: t('runGroups.MessageValidation'),
    };
    private runGroups: IRunGroupAPI[] = [];

    public load(): Promise<IRunGroupAPI[]> {
        // Only load once. If we're already loading/loaded, just return the existing promise.
        if (this.loadState === LoadState.Initial || this.loadState == LoadState.Error) {
            this.loadState = LoadState.Loading;
            
            // TODO - It may be useful to make the server url configurable so we can hit local or dev while developing.
            const url = process.env.REACT_SERVER_BASE_URL_LOCAL + '/runGroups';
            this.loadPromise = axiosServer.get<IRunGroupAPI[]>(url)
                .then((response) => {
                    this.loadState = LoadState.Success;
                    // Warn if we don't recognize any runGroup
                    for (const rg of response.data) {
                        if (!this.runGroupNames[rg.group_key]) {
                            console.warn("Unknown rungroup: ", rg);
                        }
                    }

                    return response.data;
                });
            this.loadPromise.catch((err) => {
                console.error("Error loading runGroups: ", err);
                this.loadState = LoadState.Error;
            })
        }

        return this.loadPromise;        
    }

    public getName(runGroupId: RunGroupID): string {
        return this.runGroupNames[runGroupId] || runGroupId;
    }
}

export const RunGroupsService = new _RunGroupsService();